module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/hub/front.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/hub/front.png
// module id = 575
// module chunks = 0